import dayjs from 'dayjs'

import { LineChart } from '@/pages/ui/line-chart'
import { LineChartActiveMarker } from '@/pages/ui/line-chart/line-chart-active-marker'
import { LineChartCurrentMarker } from '@/pages/ui/line-chart/line-chart-current-marker'
import { LineChartDataLine } from '@/pages/ui/line-chart/line-chart-data-line'
import { LineChartTickLines } from '@/pages/ui/line-chart/line-chart-tick-lines'
import { LineChartTooltip } from '@/pages/ui/line-chart/line-chart-tooltip'
import { LineChartXAxis } from '@/pages/ui/line-chart/line-chart-x-axis'
import { LineChartYAxis } from '@/pages/ui/line-chart/line-chart-y-axis'

import type { ResGetCaseProcessingTimeTrendItem } from '@/lib/queries/case/public/trend/processing-time/types'

import { ProcessingTimeTrendChartTooltip } from '../../../../../../../ui/chart-tooltips/processing-time-trend-chart-tooltip/processing-time-trend-chart-tooltip'
import { PLOT_AREA_PADDING_TOP, X_AXIS_HEIGHT, Y_AXIS_WIDTH } from './constants'
import { PLOT_AREA_HEIGHT } from './constants'
import { PLOT_AREA_WIDTH } from './constants'
import { PLOT_AREA_PADDING_RIGHT } from './constants'

interface Props {
  monthlySeries: ResGetCaseProcessingTimeTrendItem[]
}

export const ProcessingTimeTrendChart: React.FC<Props> = ({ monthlySeries }) => {
  return (
    <LineChart
      data={monthlySeries}
      dataKeys={['estimatedTime']}
      plotAreaWidth={PLOT_AREA_WIDTH}
      plotAreaHeight={PLOT_AREA_HEIGHT}
      plotAreaPadding={{
        right: PLOT_AREA_PADDING_RIGHT,
        top: PLOT_AREA_PADDING_TOP,
      }}
      xAxisHeight={X_AXIS_HEIGHT}
      yAxisWidth={Y_AXIS_WIDTH}
    >
      <LineChartXAxis dataKey="date" tickFormatter={formatTick} />
      <LineChartYAxis title="#Months" />
      <LineChartTickLines />
      <LineChartDataLine dataKey="estimatedTime" />
      <LineChartCurrentMarker dataKey="estimatedTime" />
      <LineChartActiveMarker dataKey="estimatedTime" />
      <LineChartTooltip dataKeys={['estimatedTime']} render={() => <ProcessingTimeTrendChartTooltip />} />
    </LineChart>
  )
}

/**
 * Produces the formatted labels for the x-axis for the given tick.
 */
const formatTick = (tick: string, index: number, length: number) => {
  const isFirst = index === 0
  const isLast = index === length - 1
  const isHalf = index === Math.floor(length / 2)
  const day = dayjs(tick)
  const labels = [day.format('MMM')]

  if (isFirst || isLast || isHalf) {
    labels.push(day.format('YYYY'))
  }

  return labels
}
